import { useCallback, useEffect, useState } from 'react';
import DataFetchParent from '../../ui/components/ui/data-fetch';
import { MassMailMetaResponseDto } from './types/response';
import useApiRequest from '../../lib/hooks/useRequest';
import { useUser } from '../../hooks/use-user';
import { useNavigate } from 'react-router-dom';
import { UserRole, UserType } from '../../lib/interfaces/user';
import { EmailPage } from './page';

const EmailPageWrapper = () => {
  const { user } = useUser();
  const { apiRequest } = useApiRequest();
  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState(true);
  const [metaResponse, setMetaResponse] = useState<MassMailMetaResponseDto>();

  const fetchMeta = useCallback(async () => {
    setIsLoading(true);
    try {
      const response = await apiRequest<MassMailMetaResponseDto>('mass-mails/internal/meta', 'GET');
      if (response.data) setMetaResponse(response.data);
    } catch (error) {
      console.error('Error fetching meta data:', error);
    } finally {
      setIsLoading(false);
    }
  }, [apiRequest]);

  useEffect(() => {
    if (!user || user.userType !== UserType.Internal || user.userRole === UserRole.User) {
      navigate('/', { replace: true });
      return;
    }

    fetchMeta();
  }, [user, navigate, fetchMeta]);

  return (
    <div className="flex flex-col gap-5 h-full">
      <div className="flex justify-between">
        <div>
          <h1 className="text-[32px] leading-[38px] font-bold text-[#12282A]">E-Mails</h1>
          <p className="text-[16px] text-[#888]">Sende E-Mails an alle gewünschten Kunden</p>
        </div>
      </div>
      <DataFetchParent data={metaResponse} renderElement={(data: MassMailMetaResponseDto) => <EmailPage mailMeta={data} />} isLoading={isLoading} />
    </div>
  );
};

export default EmailPageWrapper;
